import { FC } from 'react';
import { useRecoilState } from 'recoil';
import homeState from '../../../atoms/home';
import { UserDetail } from '../../../connector/type';
import './PlainMessage.scoped.scss'

interface PlainMessageProps {
  userId: string;
  userDetail: UserDetail | undefined;
  contents: string;
}

const PlainMessage: FC<PlainMessageProps> = ({ userId, userDetail, contents }) => {
  const [home] = useRecoilState(homeState);

  return (
    <div className="chatting-plain-message">
        <i className="chatting-plain-message__level-icon">
          <img 
            src={`/img/level/army/M${userDetail?.level ?? '1'}.gif`}
            width="23"
            height="23" 
            alt="User level icon"
          />
        </i> 
        <span className="chatting-plain-message__nickname">
          <button style={{ fontSize: home.fontSize }}>{userDetail?.nickname ?? userId}</button>
        </span>
        <span className="chatting-plain-message__contents">
          {contents}
        </span>
    </div>
  );
}

export default PlainMessage;